"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getClipId = exports.clipIdLookup = exports.ClipPathDefs = void 0;
var _react = _interopRequireDefault(require("react"));
const clipIdLookup = {
  right: "right719c1949",
  left: "left33f5edec",
  both: "bothfec15bdc",
  none: ""
};
exports.clipIdLookup = clipIdLookup;
const getClipId = (prefix, which) => `${prefix}_${clipIdLookup[which]}`;
exports.getClipId = getClipId;
const ClipPathDefs = _ref => {
  let {
    height,
    id
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", {
    viewBox: "0 0 32 32",
    width: `${height}px`,
    height: `${height}px`
  }, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: getClipId(id, "right"),
    clipPathUnits: "objectBoundingBox",
    transform: "scale(0.03125 0.03125)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 32V0H32V4.67578C26.1552 11.6974 27.1107 21.5841 32 27.3242V32H0Z"
  })), /*#__PURE__*/_react.default.createElement("clipPath", {
    id: getClipId(id, "left"),
    clipPathUnits: "objectBoundingBox",
    transform: "scale(0.03125 0.03125)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    // This is the same as the one above, but rotated 180 degrees.
    // Remember, svg rotate around their origin, not the center.
    d: "M0 32V0H32V4.67578C26.1552 11.6974 27.1107 21.5841 32 27.3242V32H0Z",
    transform: "rotate(180) translate(-32, -32)"
  })), /*#__PURE__*/_react.default.createElement("clipPath", {
    id: getClipId(id, "both"),
    clipPathUnits: "objectBoundingBox",
    transform: "scale(0.03125 0.03125)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.04812e-05 -2.79752e-06L32 0L32 4.67969C26.6898 11.0789 26.5352 20.5756 32 27.332L32 32L4.76837e-05 32L4.80925e-05 27.3242C5.84483 20.3026 4.88939 10.4159 5.00725e-05 4.67578L5.04812e-05 -2.79752e-06Z"
  }))));
};
exports.ClipPathDefs = ClipPathDefs;
//# sourceMappingURL=ClipPathDefs.js.map